import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { Observable } from 'rxjs';
import { ComparisonObject, ComparisonOperator } from 'src/app/core/api/models';
import { DialogService } from 'src/app/core/services/dialog.service';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { RoleOrganizationDto } from './../../../../core/api/models/role-organization-dto';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';

@Component({
    selector: 'app-role-organizations',
    templateUrl: './role-organizations.component.html',
    styleUrls: ['./role-organizations.component.scss'],
    imports: [BaseIndexModule]
})
export class RoleOrganizationsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties

  @Input('organizations') roleOrganizations: RoleOrganizationDto[] = [];
  @Input() loading: boolean;
  @Output('selectedOrganization') output_selectedOrganization =
    new EventEmitter<number>();

  baseItems: Array<any> = [];
  filteredItems: Array<any> = [];
  // TODO NEW SEARCH
  comparisonObjects: ComparisonObject[] | any = [];

  isTableFiltered: boolean = false;
  customOperators: [ComparisonOperator.Contains];
  //#endregion

  constructor(public dialogService: DialogService) {
    super();
  }

  ngOnInit() {
    this.configTableColumns();
    this.configPage();
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showHelpBtn = false;
    this.pageConfig.tableConfig.preloadingRowCount = 0;
    this.loading = false;
    this.pageConfig.loading = false;
    this.pageConfig.showHeader = false;
    this.pageConfig.tableConfig.hidePagination = true;
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: 'common.name',
        name: 'name',
        hasSearch: true,
        noSorting: true,
        customOperators: [ComparisonOperator.Contains],
      },
    ];
  }

  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roleOrganizations'])
      this.baseItems = Object.assign([], this.roleOrganizations);
  }

  onSelect(id) {
    if (this.loading) return;
    this.output_selectedOrganization.emit(id);
  }

  //#region search in organizations

  // TODO NEW SEARCH
  getComparisonObjects(model: any[]) {
    this.comparisonObjects = [];
    this.comparisonObjects = model;
    this.comparisonObjects.filter((object) => object.value);
    this.filterItems();
  }

  filterItems() {
    this.filteredItems = [];
    this.isTableFiltered = false;
    this.comparisonObjects.forEach((searchItem) => {
      console.log(searchItem);
      if (searchItem.comparisonObjects[0].field == 'name') {
        this.isTableFiltered = true;
        this.filteredItems = [...this.baseItems].filter((item) =>
          (item[searchItem.comparisonObjects[0].field] as string).includes(
            searchItem.comparisonObjects[0].value
          )
        );
      }
    });
    this.roleOrganizations = this.isTableFiltered
      ? this.filteredItems
      : this.baseItems;
  }
  //#endregion
}
